<template>
    <!-- Modal -->
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <Head title="ثبت اطلاعات جسمانی" />
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content modal__wrist">
                <div class="modal-header">
                    <h5 class="modal-title text-title" id="exampleModalLabel">راهنمای اندازه گیری دور مچ</h5>
                    <button type="button" id="modalWrist" class="btn-close d-inline-block p-0 m-0 me-auto" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <p class="text-md line-height justified m-0">
                        ابتدا با یک دست دور مچ خود را اندازه گرفته اگر انگشت شست و اشاره روی هم قرار گرفت دور مچ شما کوچک اگر لب به لب قرار گرفت دور مج شما متوسط و اگر بین دو انگشت فاصله افتاد دور مچ شما بزرگ است
                    </p>
                    <div class="d-flex align-content-center justify-content-around py-5">
                        <button @click.prevent="setWirst(1)" style="border: none ; background: white" class="d-flex flex-column">
                            <img src="/front/assets/images/wrist1-04.svg" alt="">
                            <p class="text-md m-0 text-center my-3">کوچک</p>
                        </button>
                        <button @click.prevent="setWirst(2)" style="border: none ; background: white" class="d-flex flex-column">
                            <img src="/front/assets/images/wrist1-05.svg" alt="">
                            <p class="text-md m-0 text-center my-3">متوسط</p>
                        </button>
                        <button @click.prevent="setWirst(3)" style="border: none ; background: white" class="d-flex flex-column">
                            <img src="/front/assets/images/wrist1-06.svg" alt="">
                            <p class="text-md m-0 text-center my-3">بزرگ</p>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--small-nav-->
    <div class="container mt-nav z-index">
        <div class="row">
            <div class="col-sm-10 col-lg-6  mx-auto">
                <div class="box__information">
                    <div class="col-12 col-md-10">
                        <p class="text-title text-white text-center pb-3">اطلاعات بدنی خود را وارد کنید</p>
                        <form @submit.prevent="store">
                            <gender v-model="form.gender" :error="form.errors.gender" class="my-3" placeHolder="جنسیت" />
                            <div class="row mt-5">
                                <div class="col-12 col-lg-3 px-4 my-3 my-lg-0 d-flex align-content-center ">
                                    <p class="text-md text-white m-0 my-auto">
                                        <img class="ms-2" src="/front/assets/images/calendar-white.svg" alt="" title="">
                                        تاریخ تولد
                                    </p>
                                </div>
                                <div class="col-4 col-sm-4 col-md-3 my-3 my-lg-0">
                                    <label class="text-white text-md mb-4 text-center w-100" for="weight">روز</label>
                                    <div class="select">
                                        <select name="birthday" id="day" v-model="form.birthday.day" >
                                            <option v-for="i in 31" >{{i}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-4 col-sm-4 col-md-3 my-3 my-lg-0">
                                    <label class="text-white text-md mb-4 text-center w-100" for="month">ماه</label>
                                        <div class="select">
                                            <select name="month" id="day" v-model="form.birthday.month" >
                                                <option v-for="(month , i) in months" :value="++i">{{month}}</option>
                                            </select>
                                        </div>
                                </div>
                                <div class="col-4 col-sm-4 col-md-3 my-3 my-lg-0">
                                    <label class="text-white text-md mb-4 text-center w-100" for="years">سال</label>
                                    <div class="select">
                                        <select name="years" id="years" v-model="form.birthday.year">
                                            <option v-for="yeas in years">{{yeas}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <wrist v-model="form.wrist" :error="form.errors.wrist"  placeHolder="دور مچ" />
                            <tall type="number" v-model="form.tall" :error="form.errors.tall"  placeHolder="" />
                            <weight v-model="form.weight" :error="form.errors.weight"  placeHolder="وزن" />


                            <div class="mt-5 text-center text-md-start">
                                <loading-button :loading="form.processing" class="tn border-0 btn-orange w-100-btn" type="submit">ادامه</loading-button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { Head } from '@inertiajs/inertia-vue3'
import LayoutFirstRegister from "../Shared/Layouts/LayoutFirstRegister";
import TextInput from "../Shared/Forms/TextInput";
import LoadingButton from "../Shared/Layouts/LoadingButton";
import Gender from "../Shared/Forms/Gender";
import SelectOption from "../Shared/Forms/SelectOption";
import Wrist from "../Shared/Forms/Wrist";
import Tall from "../Shared/Forms/Tall";
import Weight from "../Shared/Forms/Weight";
import wrist from "../Shared/Forms/Wrist";

export default {
    props : ['name','years','userData','action'],
    components: {
        TextInput,
        Gender,
        SelectOption,
        LoadingButton,
        Head,
        Wrist,
        Weight,
        Tall
    },
    layout: LayoutFirstRegister,
    data() {
        return {
            months : [
                'فروردین',
                'اردیبهشت',
                'خرداد',
                'تیر',
                'مرداد',
                'شهریور',
                'مهر',
                'آبان',
                'آذر',
                'دی',
                'بهمن',
                'اسفند',
            ],
            form: this.$inertia.form({
                action : 'insert',
                gender: '2',
                tall: '160',
                wrist: '2',
                birthday: {
                    day: '15',
                    month: '6',
                    year: '1360',
                },
                weight: '70',
            }),
        }
    },
    methods: {
        setWirst(wirst){
            const modalWrist = document.getElementById('modalWrist');
            this.form.wrist = wirst;
            modalWrist.click();
        },
        store() {
            this.form.post('/physical-information')
        },
    },
    created() {
        if (this.userData){
            this.form.birthday.year = this.userData.birthday.year;
            this.form.birthday.month = this.userData.birthday.month ;
            this.form.birthday.day = this.userData.birthday.day ;
            this.form.gender = this.userData.gender ;
            this.form.wrist = this.userData.wrist ;
            this.form.tall = this.userData.tall ;
            this.form.weight = this.userData.weight ;
            this.form.action = this.action
        }
    },

    metaInfo() {
        return {
            meta : [
                {name : 'description' , content : 'hello is my desd'}
            ]
        }
    }
}
</script>

<style scoped>

</style>
